import {action, makeAutoObservable} from "mobx"
import CategoryCompare from "../entities/CategoryCompare"
import CategoriesApi, {PairsSet} from "../../api/CategoriesApi"
import {noticeController} from "../../utils/NoticeController"

class CategoryCompareController {
    get hierarchy(): boolean {
        return this._hierarchy;
    }

    set hierarchy(value: boolean) {
        this._hierarchy = value;
        window.localStorage.setItem('_hierarchy', value ? '1' : '0')
        this.loadEntities(this._page)
    }

    private _hierarchy: boolean

    get countOfPages(): number {
        return this._countOfPages
    }

    get pageCount(): number {
        return this._pageCount
    }

    get page(): number {
        return this._page
    }

    entities: CategoryCompare[] = []
    private _page = 0
    private _pageCount = 50
    private _countOfPages = 0
    private _loadStarted = false

    constructor() {
        this._hierarchy = window.localStorage.getItem('_hierarchy') === '1'
        makeAutoObservable(this)
    }

    get entitiesLoaded(): boolean {
        return this.entities.length > 0
    }

    loadEntities(page = 0) {
        if (+this._page === +page && this._loadStarted) {
            return false
        }
        this._loadStarted = true
        this._page = page
        CategoriesApi.getWaCategories({
            page: this._page,
            pageCount: this._pageCount,
            view: this._hierarchy ? "hierarchy" : "list"
        }).then(action("waCategoriesLoaded", (result) => {
            this._loadStarted = false
            const data = result.data.data.content
            this._countOfPages = Math.ceil(result.data.data.count / result.data.data.pageCount)
            this.entities = []
            for (const category of data) {
                const entity = new CategoryCompare(category)
                this.entities.push(entity)
            }
        }))
    }

    static treeToList(categories: CategoryCompare[]): PairsSet[] {
        let data:  PairsSet[] = []
        for (const item of categories) {
            // if(item.optionValue) {
                data.push({
                    'wa_category_id': item.wa_category_id,
                    'ozon_category_id': item.optionValue ? Number(item.optionValue.value) : undefined
                })
            // }
            if (item.children.length > 0) {
                data = data.concat(CategoryCompareController.treeToList(item.children))
            }
        }
        return data
    }

    saveAll() {
        const data = CategoryCompareController.treeToList(this.entities)
        return CategoriesApi.saveAll(data).then(data => {
            noticeController.success = ['Сохранено']
            setTimeout(()=>noticeController.clearSuccess(), 1000)
        })
    }
}

const categoryCompareController = new CategoryCompareController()
export default categoryCompareController